import { FiltersDrawerIdCardsProps } from "./components/FiltersDrawerIdCards"
import { MerchantIdCardsUser, PaymentCardDetails } from "./idCardsTypes"

export function filterDataByEndUser<T extends { user: MerchantIdCardsUser; paymentCard: PaymentCardDetails }>(
    data: T[] | undefined,
    filters: FiltersDrawerIdCardsProps,
): T[] {
    if (!Array.isArray(data)) {
        return []
    }

    return data.filter((item) => {
        if (filters.email && filters.employeeId && !!filters.cardType) {
            return (
                item.user.email === filters.email &&
                item.user.employeeId === filters.employeeId &&
                item.paymentCard.cardType === filters.cardType
            )
        }

        if (filters.email) {
            return item.user.email === filters.email
        }

        if (filters.employeeId) {
            return item.user.employeeId === filters.employeeId
        }

        if (filters.cardType) {
            return item.paymentCard.cardType === filters.cardType
        }

        // If no filter is specified, return all elements
        return true
    })
}
